import { Marker, Popup, useMapEvents } from 'react-leaflet'
import { useState } from 'react'

export const LocationMarker = () => {
    const [position, setPosition] = useState(null)
    const map = useMapEvents({
        click() {
            map.locate()
        },
        locationfound(e) {
            setPosition(e.latlng)
            map.flyTo(e.latlng, map.getZoom())
        },
    })

    return position === null ? null : (
        <Marker position={position}>
            <Popup>Aqui estas</Popup>
        </Marker>
    )
}